const checklistItems = {
    // Onboaridng
    createNewTeam: 'createNewTeam',
    addTeamMembersToTeam: 'addTeamMembersToTeam',
    createFirstWorkspace: 'createFirstWorkspace',
    installFirstAutomation: 'installFirstAutomation',
    exploreStore: 'exploreStore'
}

export default checklistItems